import { apiClient } from "./apiClient";

export async function fetchIntransitData({ queryKey }) {
    const [_key, mode] = queryKey;
    const response = await apiClient(`/api/intransit/${mode}/`, {
        headers: {
            Accept: 'application/json',
        },
        credentials: 'include',
    });

    return response.json();
}
